import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  Typography,
  Stack,
  Box,
  Button,
  IconButton,
} from "@mui/material";

const defaultFooterStyle = {
  display: false,
  confirmButton: "Save",
  cancelButton: "Cancel",
  onConfirm: null,
  onCancel: null,
  isDisabled: false,
};

export const CustomeDialog = ({
  open,
  handleClose,
  content = null,
  PaperProps,
  title,
  size = "sm",
  isHeader = true,
  closeIcon,
  sx = {},
  footer = defaultFooterStyle,
  divider = true,
}) => {
  footer = { ...defaultFooterStyle, ...footer };
  const stringTitle = typeof title === "string";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={PaperProps}
      sx={{
        maxHeight: "100%",
        "& + .pac-container": {
          zIndex: 18000,
        },
      }}
    >
      {isHeader && (
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          borderBottom={stringTitle && divider ? 1 : 0}
          minHeight="52px"
          sx={
            stringTitle
              ? {
                  p: "16px",
                  borderColor: "divider",
                  height: "52px",
                }
              : {}
          }
        >
          {stringTitle ? (
            <Typography fontWeight={500} variant="body1" fontSize="20px">
              {title}
            </Typography>
          ) : (
            title
          )}
          {closeIcon && (
            // <Avatar
            //   sx={{
            //     bgcolor: " rgba(0, 0, 0, 0.03)",
            //     position: "absolute",
            //     top: size === "md" ? "11px" : "6px",
            //     right: size === "md" ? "13px" : "8px",
            //     cursor: "pointer",
            //     width: size === "md" ? 46 : 40,
            //     height: size === "md" ? 46 : 40,
            //     "&:hover": {
            //       bgcolor: "rgba(0,0,0, 0.08)",
            //     },
            //     zIndex: 2,
            //   }}
            //   variant="rounded"
            //   onClick={handleClose}
            // >
            //   <CloseIcon
            //     sx={{
            //       color: "#000",
            //     }}
            //   />
            // </Avatar>
            <IconButton
              size={size}
              onClick={handleClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon fontSize={size} />
            </IconButton>
          )}
        </Stack>
      )}
      <Box sx={sx}>{content}</Box>
      {footer.display && (
        <Stack
          display="flex"
          flexDirection="row"
          justifyContent="end"
          gap="8px"
          p="16px"
          borderTop={divider ? 1 : 0}
          borderColor="divider"
          backgroundColor="background.paper"
        >
          {typeof footer?.cancelButton === "string" ? (
            <Button
              variant="outlined"
              color="gray2"
              onClick={footer.onCancel}
              size="small"
            >
              {footer.cancelButton}
            </Button>
          ) : (
            footer.cancelButton
          )}
          {footer.onConfirm &&
            (typeof footer.confirmButton === "string" ? (
              <Button
                variant="contained"
                onClick={footer.onConfirm}
                disabled={footer.isDisabled}
              >
                {footer.confirmButton}
              </Button>
            ) : (
              footer.confirmButton
            ))}
        </Stack>
      )}
    </Dialog>
  );
};
